//#region Imports
import { AuthGoogleScope, AUTH_DEFAULT_GOOGLE_SCOPES } from "../auth-constants";
//#endregion

//#region Config
const SCOPES_VALUES = new Set(Object.values(AuthGoogleScope));
const OPEN_ID_SCOPE = "openid";
//#endregion

export function createGoogleScopesManager() {
  const scopes = new Set<AuthGoogleScope>(AUTH_DEFAULT_GOOGLE_SCOPES);

  function getScope(): string {
    return [...getScopes()].join(" ");
  }

  function getScopes(): ReadonlySet<AuthGoogleScope> {
    return scopes;
  }

  /**
   *
   * @param scope String of Google scopes
   * @return      Returns `true`if one or scopes added to current scopes
   */
  function appendScope(scope: string): boolean {
    const scopesSize = scopes.size;

    for (let s of getScopesFromScope(scope)) scopes.add(s);

    return scopes.size > scopesSize;
  }

  return {
    getScope,
    getScopes,
    appendScope,
  };
}

//#region Helpers
function getScopesFromScope(scope: string): AuthGoogleScope[] {
  if (scope === "") return [];

  const scopes = [];

  for (let s of scope.split(/\s+/)) {
    // Empty string is useless and probably programmer's code mistake
    if (!s) continue;
    // Open Id isn't relevant to us
    if (s === OPEN_ID_SCOPE) continue;

    // Assert we actually support scope
    assertSupportedScope(s);

    scopes.push(s);
  }

  return scopes;
}

function assertSupportedScope(scope: string): asserts scope is AuthGoogleScope {
  if (!SCOPES_VALUES.has(scope as any)) {
    throw new TypeError(`createGoogleScopesManager() -> assertSupportedScope(): '${scope}' is unsupported`);
  }
}
//#endregion
